import { Icon } from "@iconify/react";
import type { HighlightItem } from "@/lib/product-data/product.types";

export default function ProductHighlights({ highlights }: { highlights: HighlightItem[] }) {
  if (!highlights || highlights.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-4 mb-6">
      {highlights.map((h, i) => (
        <div key={i} className="flex items-center gap-3 p-4 rounded-xl bg-white dark:bg-white/5 border border-border dark:border-white/10">
          <div className="text-primary text-2xl">
            <Icon icon={h.icon} />
          </div>
          <div>
            <div className="text-xs text-muted dark:text-white/50 uppercase tracking-wider">{h.title}</div>
            <div className="font-bold">{h.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
